import React, { useRef, useEffect } from "react";
import styles from "./EditorEmbed.module.scss";
const Embed = ({
  value
}) => {
  const ref = useRef();
  useEffect(() => {
    const parsedHTML = document.createRange().createContextualFragment(value);
    ref.current.appendChild(parsedHTML);
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: value.includes("<iframe ") > 0 && styles.iframeContainer
  });
};
export default Embed;
//# sourceMappingURL=Embed.js.map